import { REPORTS_API } from "redux/api";

const generateQueryParams = (payload) => {
    let query = "";
    if(payload?.locationId){
        query+="&locationId="+payload?.locationId
    }else if(payload?.locationid){
        query+="&locationId="+payload?.locationid
    }

    if(payload?.startDate){
        query+="&startDate="+payload?.startDate
    }
    if(payload?.endDate){
        query+="&endDate="+payload?.endDate
    }

    if (payload?.tablePageNo !== undefined && payload?.tablePageNo !== null) {
        query += "&page=" + payload.tablePageNo;
    } else if (payload?.page !== undefined && payload?.page !== null) {
        query += "&page=" + payload.page;
    }

    if(payload?.tableRecordLimit){
        query+="&size="+payload?.tableRecordLimit
    }else if(payload?.size){
        query+="&size="+payload?.size
    }
    if(payload?.searchQuery){
        query+="&search="+payload?.searchQuery
    }else if(payload?.search|| payload?.search===""){
        query+="&search="+payload?.search
    }

    if (payload?.itemIds?.length > 0) {
        query += `&itemIds=${(payload?.itemIds || [])?.join(",")}`;
    } else if (payload?.categoryIds?.length > 0) {
        query += `&categoryIds=${(payload?.categoryIds || [])?.join(",")}`;
    }else if(payload?.groupByCategory){
        query+=`&groupByCategory=${payload?.groupByCategory}`
    }
    if(payload?.reason){
        query+=`&reason=${payload?.reason}`
    }
    if(payload?.offer){
        query+=`&offer=${payload?.offer}`
    }
    if(payload?.chartSliceName){
         query+=`&chartSliceName=${payload?.chartSliceName}`
    }

    if(payload?.type){
        query+=`&type=${payload?.type}`
   }

    if (Array.isArray(payload?.staffIds) && payload.staffIds.length > 0) {
        query += `&staffIds=${payload.staffIds.join(",")}`;
    } else if (typeof payload?.staffIds === "string" || payload?.staffIds === "") {
        query += `&staffIds=${payload?.staffIds}`;
    } else if (payload?.staffId) {
        query += `&staffId=${payload.staffId}`;
    }

    if (payload?.sortBy !== undefined && payload?.sortBy !== null && payload?.sortBy !== "") {
        query += `&sortBy=${payload?.sortBy}`;
    }

    if (payload?.sortAsc !== undefined && payload?.sortAsc !== null) {
        query += `&sortAsc=${payload?.sortAsc}`;
    }

    return "?"+query?.slice(1)
}

const generateQueryParamsForDownload = (payload) => {
    let query = "";
    if(payload?.locationId){
        query+="&locationId="+payload?.locationId
    }else if(payload?.locationid){
        query+="&locationId="+payload?.locationid
    }

    if(payload?.startDate){
        query+="&startDate="+payload?.startDate
    }
    if(payload?.endDate){
        query+="&endDate="+payload?.endDate
    }

    if (payload?.tablePageNo !== undefined && payload?.tablePageNo !== null) {
        query += "&page=" + payload.tablePageNo;
    } else if (payload?.page !== undefined && payload?.page !== null) {
        query += "&page=" + payload.page;
    }

    if(payload?.tableRecordLimit){
        query+="&size="+payload?.tableRecordLimit
    }else if(payload?.size){
        query+="&size="+payload?.size
    }
    if(payload?.searchQuery){
        query+="&search="+payload?.searchQuery
    }else if(payload?.search|| payload?.search===""){
        query+="&search="+payload?.search
    }

    if (payload?.itemIds?.length > 0) {
        query += `&itemIds=${(payload?.itemIds || [])?.join(",")}`;
    } else if (payload?.categoryIds?.length > 0) {
        query += `&categoryIds=${(payload?.categoryIds || [])?.join(",")}`;
    }else if(payload?.groupByCategory){
        query+=`&groupByCategory=${payload?.groupByCategory}`
    }
    if(payload?.reason){
        query+=`&reason=${payload?.reason}`
    }
    if(payload?.offer){
        query+=`&offer=${payload?.offer}`
    }
    if(payload?.chartSliceName){
         query+=`&chartSliceName=${payload?.chartSliceName}`
    }

    if(payload?.type !== undefined && payload?.type !== null){
        query+=`&type=${payload?.type}`
   }

    if (Array.isArray(payload?.staffIds) && payload.staffIds.length > 0) {
        query += `&staffIds=${payload.staffIds.join(",")}`;
    } else if (typeof payload?.staffIds === "string" || payload?.staffIds === "") {
        query += `&staffIds=${payload?.staffIds}`;
    } else if (payload?.staffId) {
        query += `&staffId=${payload.staffId}`;
    }

    if (payload?.sortBy !== undefined && payload?.sortBy !== null && payload?.sortBy !== "") {
        query += `&sortBy=${payload?.sortBy}`;
    }

    if (payload?.sortAsc !== undefined && payload?.sortAsc !== null) {
        query += `&sortAsc=${payload?.sortAsc}`;
    }

    return "?"+query?.slice(1)
}

export const getEmployeeSummaryDetailedTable = (employeeSummaryDetailedTablePayload) => {
    // console.log({employeeSummaryDetailedTablePayload})
    const query=generateQueryParams(employeeSummaryDetailedTablePayload)
    // console.log("getEmployeeSummaryDetailedTable", query)
    return REPORTS_API({
        method: "get",
        url: `/sales/employee/staff-clockings${query}`,
    });
};

export const getDownloadableReportForEmployeeTab = (payload) => {
    const {apiEndPoint, ...queryParams}=payload
    const query=generateQueryParamsForDownload(queryParams)

    return REPORTS_API({
        method: "get",
        url: `${apiEndPoint}${query}`,
    });
}
